module.exports = __webpack_public_path__ + "static/author2-dc3bdcb5c0fdf0212885612c451a7f45.png";